import { render, staticRenderFns } from "./chatView.vue?vue&type=template&id=16ee67bc&scoped=true&"
import script from "./chatView.vue?vue&type=script&lang=js&"
export * from "./chatView.vue?vue&type=script&lang=js&"
import style0 from "./chatView.vue?vue&type=style&index=0&id=16ee67bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ee67bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16ee67bc')) {
      api.createRecord('16ee67bc', component.options)
    } else {
      api.reload('16ee67bc', component.options)
    }
    module.hot.accept("./chatView.vue?vue&type=template&id=16ee67bc&scoped=true&", function () {
      api.rerender('16ee67bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tracking/partials/chatView.vue"
export default component.exports